import { render } from "./LoanDetails.vue?vue&type=template&id=930702a4&scoped=true&ts=true"
import script from "./LoanDetails.vue?vue&type=script&lang=ts"
export * from "./LoanDetails.vue?vue&type=script&lang=ts"

import "./LoanDetails.vue?vue&type=style&index=0&id=930702a4&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-930702a4"]])

export default __exports__